import React from 'react';
import './OperaCloudCompare.css';

// Shared live dry-run result view — used by the wizard Test step and the detail page Dry-run panel.
// `result` = { connected, hotelId, subareas:[{ subarea_key, label, checks:[{ check_key, title, ok, count, error }] }],
//              testedChecks, totalChecks, capped }

const DryftDryRunResult = ({ result, loading, error }) => {
    if (loading) return <div className="pi-empty"><p className="pi-empty-text">Running a live test against OHIP…</p></div>;
    if (error) return <div className="ppw-error-msg" style={{ margin: '8px 0' }}>{error}</div>;
    if (!result) return null;

    const subareas = result.subareas || [];
    return (
        <div className="dryft-dryrun">
            <div className="dryft-dryrun-status">
                <span className="dryft-dryrun-ok">✓ Connected to OHIP</span>
                {result.hotelId ? <span className="dryft-dryrun-hotel"> · hotel {result.hotelId}</span> : null}
            </div>
            {result.capped && (
                <div className="dryft-dryrun-capped">Showing the first {result.testedChecks} of {result.totalChecks} checks.</div>
            )}
            {subareas.length === 0 ? (
                <div className="occ-instance-hint">No checks to preview for the selected configuration.</div>
            ) : subareas.map(s => (
                <div key={s.subarea_key} className="dryft-dryrun-sub">
                    <div className="dryft-dryrun-sub-label">{s.label}</div>
                    <div className="dryft-dryrun-checks">
                        {s.checks.map(c => (
                            <div key={c.check_key} className={`dryft-dryrun-check ${c.ok ? 'ok' : 'err'}`}>
                                <span className="dryft-dryrun-check-title">{c.title}</span>
                                {c.ok
                                    ? <span className="dryft-dryrun-count">{c.count} item{c.count === 1 ? '' : 's'}</span>
                                    : <span className="dryft-dryrun-badge-err" title={c.error}>error</span>}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default DryftDryRunResult;
